import type { ButtonHTMLAttributes, Ref } from "react";
import "./link-button.css";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Arriva al `<button>` (in React 19 `ref` è una prop), per riportarvi il focus. */
  ref?: Ref<HTMLButtonElement>;
};

// Un'azione dentro una frase che si legge come un link («Password dimenticata?»): resta un `<button>`,
// perché non porta a un'altra pagina. Per andare altrove si usa un link vero.
export function LinkButton({ type = "button", className, ...rest }: Props) {
  return <button type={type} className={className ? `g-link-button ${className}` : "g-link-button"} {...rest} />;
}
